// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".option.with-image[data-v-e1e702f2]{align-items:center;display:inline-flex;flex-direction:column;font-size:13px!important;justify-content:flex-start;padding:7px;text-align:center;width:95px}.option.with-image[data-v-e1e702f2] img{border-radius:4px;height:70px;margin-bottom:4px;width:70px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
